import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";function ownKeys(object, enumerableOnly) {var keys = _Object$keys(object);if (_Object$getOwnPropertySymbols) {var symbols = _Object$getOwnPropertySymbols(object);enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {return _Object$getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));});}return target;}import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import clsx from 'clsx';
import ChevronRight from "../../icons/ChevronRight";
import React, { useState, useEffect } from 'react';

import { createStyles } from "./styles";

var Tabs = function Tabs(props) {
  var tabs = props.tabs,onTabsChangeCallback = props.onTabsChangeCallback,className = props.className;
  // React state
  var _useState = useState(props.currentTabId || tabs[0].id),_useState2 = _slicedToArray(_useState, 2),currentTabId = _useState2[0],setCurrentTabId = _useState2[1];
  var _useState3 = useState(
    props.currentSubTabId || (tabs[0].subTabs ? tabs[0].subTabs[0].id : null)),_useState4 = _slicedToArray(_useState3, 2),currentSubTabId = _useState4[0],setCurrentSubTabId = _useState4[1];

  var _useState5 = useState({}),_useState6 = _slicedToArray(_useState5, 2),tabAndComponentMap = _useState6[0],setTabAndComponentMap = _useState6[1];

  // Component actions
  function onTabClickOwn(tabId) {
    setCurrentTabId(tabId);
    var currentTabObj = _findInstanceProperty(tabs).call(tabs, function (tab) {return tab.id === tabId;});
    if (!(currentTabObj !== null && currentTabObj !== void 0 && currentTabObj.componentToRender)) {
      setCurrentSubTabId(currentTabObj !== null && currentTabObj !== void 0 && currentTabObj.subTabs ? currentTabObj.subTabs[0].id : null);
    } else {
      setCurrentSubTabId(null);
    }
  }

  function onSubTabClickOwn(subTabId) {
    setCurrentSubTabId(subTabId);
  }

  function onKeyPressHandler(
  e,
  cb)
  {
    if (e.keyCode === 13) {
      cb();
    }
  }

  function processTabInteractionReaction(
  elemId,
  ownHandlerCb,
  propHandlerCb)
  {
    ownHandlerCb(elemId);
    if (propHandlerCb) {
      propHandlerCb(elemId);
    }
  }

  function constructTabAndComponentMap(tabsItems) {
    var resultObj = {};
    tabsItems.forEach(function (tab) {var _tab$subTabs;
      resultObj[tab.id] = tab.componentToRender;
      (_tab$subTabs = tab.subTabs) === null || _tab$subTabs === void 0 ? void 0 : _tab$subTabs.forEach(function (subTab) {
        resultObj[subTab.id] = subTab.componentToRender;
      });
    });
    return resultObj;
  }

  // React effects
  useEffect(function () {
    if (onTabsChangeCallback) {
      onTabsChangeCallback(currentTabId, currentSubTabId);
    }
  }, [currentTabId, currentSubTabId]);

  useEffect(function () {
    setTabAndComponentMap(constructTabAndComponentMap(tabs));
  }, [tabs]);

  // Concomitant layout
  var classes = createStyles(props);

  function SubTabComponent(
  subTabProps,
  onActionCb)
  {
    return /*#__PURE__*/(
      React.createElement("li", {
        key: subTabProps.id,
        id: subTabProps.id,
        role: "menuitem",
        onClick: function onClick() {
          onActionCb();
        },
        onKeyDown: function onKeyDown(e) {
          onKeyPressHandler(e, function () {return onActionCb();});
        },
        className: clsx(
        classes.subTabButton,
        subTabProps.className,
        subTabProps.id === props.currentSubTabId && (
        subTabProps.activeClassName || classes.subTabButtonActive)) },


      subTabProps.id === props.currentSubTabId && (
      subTabProps.icon || /*#__PURE__*/React.createElement(ChevronRight, { width: "2.4rem" })), "\xA0",

      subTabProps.title));


  }

  function renderSubTabComponent(subTabItem) {
    var subTabOnActionCb = function subTabOnActionCb() {return (
        processTabInteractionReaction(
        subTabItem.id,
        onSubTabClickOwn,
        subTabItem.onSubTabClickCallback));};


    return SubTabComponent(_objectSpread({}, subTabItem), subTabOnActionCb);
  }

  var TabComponent = function TabComponent(
  tabProps,
  onActionCb) {var _context;return /*#__PURE__*/(

      React.createElement(React.Fragment, { key: tabProps.id }, /*#__PURE__*/
      React.createElement("li", {
        role: "menuitem",
        id: tabProps.id,
        onClick: function onClick() {return onActionCb();},
        onKeyDown: function onKeyDown(e) {return onKeyPressHandler(e, function () {return onActionCb();});},
        className: clsx(
        classes.tabButton,
        tabProps.className,
        tabProps.id === currentTabId && (tabProps.activeClassName || classes.tabButtonActive)) },


      tabProps.icon, " \xA0 ", tabProps.title),

      tabProps.id === currentTabId && tabProps.subTabs && /*#__PURE__*/
      React.createElement("ul", { role: "menu", className: classes.subTabsButtonsWrapper },
      _mapInstanceProperty(_context = tabProps.subTabs).call(_context, function (subTabItem) {return renderSubTabComponent(subTabItem);}))));};





  function renderTabComponent(tabItem) {
    var tabOnActionCb = function tabOnActionCb() {return (
        processTabInteractionReaction(tabItem.id, onTabClickOwn, tabItem.onTabClickCallback));};
    return TabComponent(_objectSpread({}, tabItem), tabOnActionCb);
  }

  return /*#__PURE__*/(
    React.createElement("section", { className: clsx(classes.tabsComponentWrapper, className) }, /*#__PURE__*/
    React.createElement("aside", { className: classes.controllersSection }, /*#__PURE__*/
    React.createElement("ul", { className: classes.tabsButtonsWrapper, role: "menu" },
    _mapInstanceProperty(tabs).call(tabs, function (tab) {return renderTabComponent(tab);}))),


    tabAndComponentMap && tabAndComponentMap[currentSubTabId || currentTabId]));


};

export default Tabs;
//# sourceMappingURL=index.js.map